import FetcherTableSkeleton from "../FetcherTableSkeleton";

/** Placeholder that mirrors InterfacesTable while the catalogue is loading. */
const InterfacesSkeleton = () => <FetcherTableSkeleton columns={8} />;

export default InterfacesSkeleton;
